<template>
  <div class="spin-illustration-card">
    <div class="illustration">
      <svg
        v-if="illustration === 'walking-man'"
        width="113"
        height="113"
        viewBox="0 0 113 113"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M61.5938 32.1875C67.4445 32.1875 72.1875 27.4445 72.1875 21.5938C72.1875 15.743 67.4445 11 61.5938 11C55.743 11 51 15.743 51 21.5938C51 27.4445 55.743 32.1875 61.5938 32.1875Z"
          fill="var(--accentColor)"
        />
        <path
          d="M67.0938 31.7812C72.9445 31.7812 77.6875 27.0383 77.6875 21.1875C77.6875 15.3367 72.9445 10.5938 67.0938 10.5938C61.243 10.5938 56.5 15.3367 56.5 21.1875C56.5 27.0383 61.243 31.7812 67.0938 31.7812Z"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M85.0138 58L82.3582 102.853"
          stroke="var(--accentColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21.1875 56.5002C21.1875 56.5002 45.9062 31.7814 60.0312 44.847C67.9324 52.1302 74.1562 63.5627 91.8125 63.5627"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M57.6035 42.9932L31.7812 102.406"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M90 57L87.3444 101.852"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M67.0938 102.406V77.6875L48.334 64.3129"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <svg
        v-if="illustration === 'running-man'"
        width="164"
        height="113"
        viewBox="0 0 164 113"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6 46.3587C27.6978 62.5599 38.8788 28.4439 62.3478 46.3587"
          stroke="var(--accentColor)"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M2 46.2109C23.6978 62.4121 34.8788 28.2961 58.3478 46.2109"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M13.0435 61.2113C35.2837 79.727 46.7442 40.7372 70.8 61.2113"
          stroke="var(--accentColor)"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M9.04346 61.0634C31.2837 79.5791 42.7442 40.5894 66.8 61.0634"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M6 75.9413C27.6978 92.1426 38.8788 58.0266 62.3478 75.9413"
          stroke="var(--accentColor)"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M2 75.7935C23.6978 91.9947 34.8788 57.8787 58.3478 75.7935"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
        />
        <path
          d="M75.9565 44.7262C75.9565 44.7262 90.0435 31.6958 111.174 48.248C133.405 65.5925 146.391 58.8132 146.391 58.8132"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M110.778 47.8957C108.841 56.8761 96.0305 91.125 65.3914 88.0435"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M99.9924 70.963C107.872 72.6358 128.783 79.2391 128.783 102.13"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M111.594 39.5938C117.445 39.5938 122.188 34.8508 122.188 29C122.188 23.1492 117.445 18.4062 111.594 18.4062C105.743 18.4062 101 23.1492 101 29C101 34.8508 105.743 39.5938 111.594 39.5938Z"
          fill="var(--accentColor)"
        />
        <path
          d="M117.094 39.1875C122.945 39.1875 127.688 34.4445 127.688 28.5938C127.688 22.743 122.945 18 117.094 18C111.243 18 106.5 22.743 106.5 28.5938C106.5 34.4445 111.243 39.1875 117.094 39.1875Z"
          stroke="var(--contrastColor)"
          stroke-width="3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="text-container">
      <h2>{{ heading }}</h2>
      <h4 v-if="subheading">{{ subheading }}</h4>
      <p v-for="(text, index) in body" :key="index">{{ text }}</p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: ["heading", "subheading", "body", "illustration"],
};
</script>
<style scoped>
.spin-illustration-card {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 375px;
  height: 500px;
  padding: 30px;
  margin: 15px;
  box-sizing: border-box;
  border: 1px solid var(--secondaryColor);
  border-radius: 8px;
  filter: drop-shadow(0 0 2px var(--secondaryColor));
  background-color: var(--backgroundColor);
  cursor: pointer;
}
.spin-illustration-card:hover {
  filter: drop-shadow(0 2px 2px var(--secondaryColor));
}
</style>
